import { Link } from 'react-router-dom';

const articles = [
  {
    tag: 'Guia',
    tagClass: 'bg-primary-100 text-primary-800',
    title: 'Como Usar o CSSBuy Spreadsheet: Guia Completo 2026',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20clean%20desk%20setup%20with%20laptop%20displaying%20organized%20spreadsheet%20data%20warm%20ambient%20lighting%20cream%20walls%20wooden%20desk%20modern%20workspace%20editorial%20photography%20soft%20shadows%20elegant%20composition%20professional%20setup%20no%20text%20no%20logos%20cozy%20natural%20atmosphere&width=800&height=560&seq=article-card-guia-v2-01&orientation=landscape',
    link: '/guia-cssbuy-sheet/',
    featured: false,
  },
  {
    tag: 'Comparação',
    tagClass: 'bg-accent-100 text-accent-800',
    title: 'CSSBuy vs PandaBuy: Comparação Completa e Atualizada',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20side%20by%20side%20concept%20with%20two%20distinct%20product%20collections%20neatly%20arranged%20on%20warm%20cream%20surface%20soft%20natural%20window%20lighting%20clean%20editorial%20photography%20beige%20palette%20balanced%20composition%20no%20text%20no%20logos%20elegant%20comparison%20aesthetic&width=800&height=560&seq=article-card-compare-v2-02&orientation=landscape',
    link: '/artigo/cssbuy-vs-pandabuy/',
    featured: true,
  },
  {
    tag: 'Segurança',
    tagClass: 'bg-secondary-100 text-secondary-800',
    title: 'CSSBuy é Seguro? Guia de Segurança e Confiabilidade',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20security%20trust%20concept%20with%20sleek%20metallic%20lock%20beside%20neatly%20arranged%20fashion%20items%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20clean%20editorial%20photography%20beige%20palette%20calm%20confident%20composition%20no%20text%20no%20logos%20elegant%20styling&width=800&height=560&seq=article-card-safety-v2-03&orientation=landscape',
    link: '/artigo/cssbuy-seguranca/',
    featured: false,
  },
  {
    tag: 'Lista',
    tagClass: 'bg-primary-100 text-primary-800',
    title: 'CSSBuy Spreadsheet 2026: Lista Atualizada de Produtos',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20organized%20product%20catalog%20grid%20with%20fashion%20items%20neatly%20grouped%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20clean%20editorial%20photography%20beige%20palette%20structured%20layout%20no%20text%20no%20logos%20modern%20catalog%20aesthetic&width=800&height=560&seq=article-card-list-v2-04&orientation=landscape',
    link: '/artigo/cssbuy-spreadsheet-lista-2026/',
    featured: false,
  },
  {
    tag: 'Review',
    tagClass: 'bg-accent-100 text-accent-800',
    title: 'Vale a Pena Usar o CSSBuy em 2026? Análise Completa',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20decision%20concept%20with%20fashion%20accessories%20arranged%20around%20subtle%20visual%20balance%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20clean%20editorial%20photography%20beige%20palette%20thoughtful%20composition%20no%20text%20no%20logos%20elegant%20product%20styling&width=800&height=560&seq=article-card-worth-v2-05&orientation=landscape',
    link: '/artigo/vale-a-pena-cssbuy/',
    featured: false,
  },
  {
    tag: 'Produtos',
    tagClass: 'bg-secondary-100 text-secondary-800',
    title: 'Os Melhores Produtos do CSSBuy em 2026: Top Picks',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20curated%20premium%20fashion%20collection%20elegantly%20displayed%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20clean%20editorial%20photography%20beige%20palette%20sophisticated%20composition%20no%20text%20no%20logos%20luxury%20product%20styling&width=800&height=560&seq=article-card-best-v2-06&orientation=landscape',
    link: '/artigo/melhores-produtos-cssbuy/',
    featured: false,
  },
  {
    tag: 'Guia',
    tagClass: 'bg-primary-100 text-primary-800',
    title: 'Guia Completo do CSSBuy para Iniciantes: Primeiros Passos',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20welcoming%20desk%20setup%20with%20laptop%20and%20fashion%20items%20neatly%20arranged%20on%20warm%20cream%20surface%20soft%20natural%20window%20lighting%20clean%20editorial%20photography%20beige%20palette%20inviting%20composition%20no%20text%20no%20logos%20modern%20beginner%20workspace%20aesthetic&width=800&height=560&seq=article-card-beginner-v2-07&orientation=landscape',
    link: '/artigo/guia-iniciantes-cssbuy/',
    featured: false,
  },
  {
    tag: 'Top 10',
    tagClass: 'bg-accent-100 text-accent-800',
    title: '10 Produtos Mais Populares no CSSBuy em 2026',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20trending%20fashion%20items%20displayed%20in%20dynamic%20clean%20arrangement%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20modern%20editorial%20photography%20beige%20palette%20energetic%20elegant%20composition%20no%20text%20no%20logos%20contemporary%20styling&width=800&height=560&seq=article-card-popular-v2-08&orientation=landscape',
    link: '/artigo/produtos-populares-cssbuy/',
    featured: false,
  },
  {
    tag: 'Brasil',
    tagClass: 'bg-secondary-100 text-secondary-800',
    title: 'CSSBuy Spreadsheet Brasil: Guia Atualizado 2026',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20tropical%20inspired%20fashion%20flat%20lay%20with%20warm%20earth%20tones%20and%20product%20arrangements%20on%20cream%20surface%20soft%20natural%20lighting%20clean%20editorial%20photography%20subtle%20green%20accents%20elegant%20composition%20no%20text%20no%20logos%20sophisticated%20Brazil%20theme&width=800&height=560&seq=article-card-brazil-v2-09&orientation=landscape',
    link: '/artigo/cssbuy-brasil-guia/',
    featured: false,
  },
  {
    tag: 'Dicas',
    tagClass: 'bg-primary-100 text-primary-800',
    title: 'Como Economizar no Frete do CSSBuy: 12 Dicas',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20packaging%20and%20savings%20concept%20with%20neatly%20wrapped%20fashion%20items%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20clean%20editorial%20photography%20beige%20palette%20smart%20practical%20composition%20no%20text%20no%20logos%20elegant%20styling%20with%20subtle%20financial%20hints&width=800&height=560&seq=article-card-save-v2-10&orientation=landscape',
    link: '/artigo/economizar-frete-cssbuy/',
    featured: false,
  },
  {
    tag: 'Comparação',
    tagClass: 'bg-accent-100 text-accent-800',
    title: 'CSSBuy vs Superbuy: Qual a Melhor Plataforma?',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20duel%20concept%20with%20two%20distinct%20fashion%20collections%20arranged%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20clean%20editorial%20photography%20beige%20palette%20balanced%20competitive%20composition%20no%20text%20no%20logos%20elegant%20versus%20styling&width=800&height=560&seq=article-card-vs-v2-11&orientation=landscape',
    link: '/artigo/cssbuy-vs-superbuy/',
    featured: false,
  },
  {
    tag: 'Avançado',
    tagClass: 'bg-secondary-100 text-secondary-800',
    title: 'Dicas Avançadas para CSSBuy Spreadsheet em 2026',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20professional%20tools%20and%20premium%20fashion%20items%20elegantly%20arranged%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20clean%20editorial%20photography%20beige%20palette%20sophisticated%20expert%20composition%20no%20text%20no%20logos%20premium%20styling&width=800&height=560&seq=article-card-advanced-v2-12&orientation=landscape',
    link: '/artigo/dicas-avancadas-cssbuy/',
    featured: false,
  },
];

export default function ArticleCards() {
  return (
    <section id="artigos" className="py-16 md:py-24 px-6 md:px-10 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        {/* Header - asymmetric layout */}
        <div className="flex flex-col lg:flex-row lg:items-end gap-6 mb-14">
          <div className="flex-1">
            <h2 className="font-heading text-2xl md:text-3xl font-normal text-foreground-500">
              Artigos e
            </h2>
            <h2 className="font-heading text-3xl md:text-4xl font-bold italic text-foreground-950 mt-1">
              CSSBuy Sheet
            </h2>
          </div>
          <div className="lg:w-[45%]">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              Descubra nossos guias completos e artigos otimizados sobre CSSBuy Spreadsheet. 
              Aprenda a comprar, comparar plataformas e encontrar os melhores produtos com segurança.
            </p>
          </div>
        </div>

        {/* Article Cards Grid - 12 cards, 3 cols desktop */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
          {articles.map((article, idx) => (
            <Link
              key={idx}
              to={article.link}
              className={`group block rounded-2xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:-translate-y-1 ${
                article.featured
                  ? 'bg-foreground-950 text-white border-foreground-800 md:col-span-2 md:row-span-1'
                  : 'bg-background-50'
              }`}
            >
              {/* Image area */}
              <div className={`relative overflow-hidden ${article.featured ? 'h-[260px]' : 'h-[200px]'}`}>
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                {article.featured && (
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/40 to-transparent"></div>
                )}
              </div>

              {/* Content */}
              <div className="p-5">
                <span
                  className={`inline-block px-3 py-1 rounded-full text-xs font-medium mb-3 ${article.tagClass} ${
                    article.featured ? 'bg-primary-500/20 text-primary-300' : ''
                  }`}
                >
                  {article.tag}
                </span>
                <h3
                  className={`text-sm md:text-base font-semibold leading-snug mb-2 line-clamp-3 ${
                    article.featured ? 'text-background-50' : 'text-foreground-900'
                  }`}
                >
                  {article.title}
                </h3>
                <span
                  className={`inline-flex items-center gap-1 text-xs md:text-sm font-medium mt-2 ${
                    article.featured ? 'text-primary-400' : 'text-primary-600'
                  }`}
                >
                  Ler artigo
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}